import React, { useState, useCallback, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Permissions from '../Components/Permissions';
import { isPathActive } from '../Components/Permissions/Permissions';

function Sidebar(props) {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState({});

  const userRole = JSON.parse(localStorage.getItem('user'));
  const userPermissions = JSON.parse(localStorage.getItem('permissions'));

  const toggleMenuState = (menuState) => {
    if (state[menuState]) {
      setState({ [menuState]: false });
    } else if (Object.keys(state).length === 0) {
      setState({ [menuState]: true });
    } else {
      Object.keys(state).forEach((i) => {
        setState({ [i]: false });
      });
      setState({ [menuState]: true });
    }
  };

  useEffect(() => {
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }, []);

  useEffect(() => {
    onRouteChanged();
  }, [props.location]);

  const onRouteChanged = () => {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(state).forEach((i) => {
      setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/models-plug-type', state: 'modelsPlugTypeMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
    ];

    dropdownPaths.forEach((obj) => {
      if (isPathActive(obj.path)) {
        setState({ [obj.state]: true });
      }
    });
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
        <Link className="sidebar-brand brand-logo" to="/">
          <img src={require('../../assets/images/logo-2.png')} alt="logo" />
        </Link>
        <Link className="sidebar-brand brand-logo-mini" to="/">
          <img src={require('../../assets/images/logo-mini-1.png')} alt="logo" />
        </Link>
      </div>

      <ul className="nav">
        <li className="nav-item nav-category">
          <span className="nav-link">{t('navigation_title')}</span>
        </li>
        <Permissions
          menu="dashboard"
          linkTo="/dashboard"
          icone="mdi mdi-home"
          trans="navigation_menu_dashboard_title"
        />
        <Permissions
          menu="menu-permissions"
          linkTo="/menu-permissions"
          icone="mdi mdi-sitemap"
          trans="navigation_menu_menu-permissions_title"
        />
        <Permissions
          menu="workers"
          linkTo="/workers"
          icone="mdi mdi-account-multiple"
          trans="navigation_menu_workers_title"
        />
        <Permissions
          menu="companies"
          linkTo="/companies"
          icone="mdi mdi-blur"
          trans="navigation_menu_company_title"
        />
        <Permissions
          menu="help"
          linkTo="/help"
          icone="mdi mdi-help-circle-outline"
          trans="navigation_menu_help_title"
        />

        {/* <li
          className={isPathActive('/models-plug-type') ? 'nav-item menu-items active' : 'nav-item menu-items'}
        >
          <div
            className={state.modelsPlugTypeMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => toggleMenuState('modelsPlugTypeMenuOpen')}
            data-toggle="collapse"
          >
            <span className="menu-icon">
              <i className="mdi mdi-book-multiple"></i>
            </span>
            <span className="menu-title">{t('navigation_menu_models_plugType_title')}</span>
            <i className="mdi mdi-chevron-down"></i>
          </div>
          <Collapse in={state.modelsPlugTypeMenuOpen}>
            <div>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/models-plug-type/models') ? 'nav-link active' : 'nav-link'}
                    to="/models-plug-type/models"
                  >
                    {t('navigation_menu_models_plugType_child_stationModels_title')}
                  </Link>
                </li>
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/models-plug-type/plug-type') ? 'nav-link active' : 'nav-link'}
                    to="/models-plug-type/plug-type"
                  >
                    {t('navigation_menu_models_plugType_child_StationPlugType_title')}
                  </Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li className="nav-item nav-category">
          <span className="nav-link">Example</span>
        </li>
        <li className={isPathActive('/basic-ui') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
          <div
            className={state.basicUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => toggleMenuState('basicUiMenuOpen')}
            data-toggle="collapse"
          >
            <span className="menu-icon">
              <i className="mdi mdi-laptop"></i>
            </span>
            <span className="menu-title">Basic UI Elements</span>
            <i className="mdi-chevron-down"></i>
          </div>
          <Collapse in={state.basicUiMenuOpen}>
            <div>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/basic-ui/buttons') ? 'nav-link active' : 'nav-link'}
                    to="/basic-ui/buttons"
                  >
                    Buttons
                  </Link>
                </li>
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/basic-ui/dropdowns') ? 'nav-link active' : 'nav-link'}
                    to="/basic-ui/dropdowns"
                  >
                    Dropdowns
                  </Link>
                </li>
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/basic-ui/typography') ? 'nav-link active' : 'nav-link'}
                    to="/basic-ui/typography"
                  >
                    Typography
                  </Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li className={isPathActive('/tables') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
          <div
            className={state.tablesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => toggleMenuState('tablesMenuOpen')}
            data-toggle="collapse"
          >
            <span className="menu-icon">
              <i className="mdi mdi-table-large"></i>
            </span>
            <span className="menu-title">Tables</span>
            <i className="mdi-chevron-down"></i>
          </div>
          <Collapse in={state.tablesMenuOpen}>
            <div>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/tables/basic-table') ? 'nav-link active' : 'nav-link'}
                    to="/tables/basic-table"
                  >
                    Basic Table
                  </Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li className={isPathActive('/icons') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
          <div
            className={state.iconsMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => toggleMenuState('iconsMenuOpen')}
            data-toggle="collapse"
          >
            <span className="menu-icon">
              <i className="mdi mdi-contacts"></i>
            </span>
            <span className="menu-title">Icons</span>
            <i className="mdi-chevron-down"></i>
          </div>
          <Collapse in={state.iconsMenuOpen}>
            <div>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/icons/mdi') ? 'nav-link active' : 'nav-link'}
                    to="/icons/mdi"
                  >
                    Material
                  </Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li className={isPathActive('/user-pages') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
          <div
            className={state.userPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => toggleMenuState('userPagesMenuOpen')}
            data-toggle="collapse"
          >
            <span className="menu-icon">
              <i className="mdi mdi-security"></i>
            </span>
            <span className="menu-title">User Pages</span>
            <i className="mdi-chevron-down"></i>
          </div>
          <Collapse in={state.userPagesMenuOpen}>
            <div>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  {' '}
                  <Link className={isPathActive('/login') ? 'nav-link active' : 'nav-link'} to="/login">
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  {' '}
                  <Link
                    className={isPathActive('/register/register') ? 'nav-link active' : 'nav-link'}
                    to="/register/register"
                  >
                    Register
                  </Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li> */}
      </ul>
    </nav>
  );
}

export default withRouter(Sidebar);
